import * as React from "react";
import {SVGProps} from "react";

const IconMegaPhone = (props: SVGProps<SVGSVGElement> & { title: string }) => {
    const {color = "#131622", title, ...rest} = props;
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        role="img"
        {...rest}
    >
        <title>{title ?? "Roadmap"}</title>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M8.34 13.84a24.29 24.29 0 0 0-2.09-.09H5.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.028 18.028 0 0 1-.59-4.59c0-1.586.205-3.125.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M8.34 4.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 16.795 1m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.034.811 1.73s-.316 1.317-.811 1.73m0-3.46a24.348 24.348 0 0 1 0 3.46"
        />
    </svg>;
};
export default IconMegaPhone;
